import { jsx as _jsx } from "react/jsx-runtime";
import styles from './IconBox.module.scss';
import cn from 'classnames';
const IconBox = ({ children, type = 1, className, link, onClick }) => {
    return (_jsx("a", Object.assign({ href: link, onClick: onClick, className: cn(className, styles.element, 'd-flex align-items-center justify-content-center', styles[`hasType-${type}`]) }, { children: children })));
};
export default IconBox;
